import { Effect } from "../Materials/effect";
import "./ShadersInclude/logDepthDeclaration";
import "./ShadersInclude/logDepthFragment";
var name = 'outlinePixelShader';
var shader = "#ifdef LOGARITHMICDEPTH\n#extension GL_EXT_frag_depth : enable\n#endif\nuniform vec4 color;\n#ifdef ALPHATEST\nvarying vec2 vUV;\nuniform sampler2D diffuseSampler;\n#endif\n#include<logDepthDeclaration>\nvoid main(void) {\n#ifdef ALPHATEST\nif (texture2D(diffuseSampler,vUV).a<0.4)\ndiscard;\n#endif\n#include<logDepthFragment>\ngl_FragColor=color;\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var outlinePixelShader = { name: name, shader: shader };
//# sourceMappingURL=outline.fragment.js.map